import common = require("../../common");
import SearchBox = require("../../core/SearchBox");
import HotEditableFormManager = require("./hotEditable/HotEditableFormManager");
import Vue from 'vue';
import Component from 'vue-class-component';
import utilities = require("../utilities");
import SharedHotEditableParentForm = require("./hotEditable/SharedHotEditableParentForm");
import HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader");
import HotEditableCheckboxComponent = require("./hotEditable/HotEditableCheckboxComponent");

//declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require('../../js/jsClasses');

interface ICurrentSorter {
    name: string,
    order: common.SortOrderTypes
}

// The @Component decorator indicates the class is a Vue component
@Component
class SearchBoxResultsVue extends Vue implements common.IHotEditableFormParentVue {
    searchBox: SearchBox;
    searchFieldStandardValue = '';
    activeBannerId = '';
    searchParametersSorter = [] as common.ISearchSorter[];
    items = [] as common.ISearchBoxResult[];
    totalResults = 0;
    isInitialized = false;
    searchIsRunning = false;
    sbFilters = {};
    sbFilterOptions = {};
    initialData: any;
    actions: common.ISearchBoxAction[];
    actionsPopupTitle = '';
    actionsPopupIsOpen = false;
    sorterPopupIsOpen = false;
    showExportButton = false;
    itemsSelection = common.SearchBoxItemsSelectionTypes.nothing;
    noResultText: string;

    // Proprietes utilisees pour les sorters
    currentSorter = null as ICurrentSorter;
    currentSorterPopupName = null as string;
    sortersRegistry = {} as any;

    shared: SharedHotEditableParentForm;
    formMode = common.HotEditableFormModes.original;
    formManager: HotEditableFormManager;

    _onAction = null as (type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean, selectedItems: common.ISelectedItem[]) => void;
    _defaultNoResultText: string;
    _goToServerOnItemClick: boolean;

    private _sorterCallback?: (name: string, order: string) => void;
    private _onInfiniteScrollLoadMoreCallback?: () => void;
    private _onExportButtonCallback?: () => void;

    beforeCreate() {
        HotEditableFormLoader.loadComponentsFromParent(this);

        this.searchBox = (this.initialData as common.ISearchBoxResultsInitialData).searchBox;
        this.$options.el = (this.initialData as common.ISearchBoxResultsInitialData).el;
        this._defaultNoResultText = (this.initialData as common.ISearchBoxResultsInitialData).defaultNoResultText || '';
        this._goToServerOnItemClick = (this.initialData as common.ISearchBoxResultsInitialData).goToServerOnItemClick;
        const actions = (this.initialData as common.ISearchBoxResultsInitialData).actions;
        this.actions = [];
        // Activer par defaut les actions (sera refactorise lors du rework des QuickActions dynamiques).
        for (let i = 0; i < (actions || []).length; i++) {
            const a = actions[i];
            a.isEnable = true;
            this.actions.push(a);
        }

        this.formManager = new HotEditableFormManager(this, (this.initialData as common.ISearchBoxResultsInitialData).formName);
        this.shared = new SharedHotEditableParentForm(this.formManager);
    }

    created() {
    }

    mounted() {
        this.setupResults();
        this.setupSorters();
        this.setupActions();
    }

    private setupResults() {
        this.items = [];
    }

    private setupSorters() {
        // permet de faire fermer la popup lorsque l'utilisateur click a l'exterieur de la popup
        document.addEventListener("click", e => {
            const el = e.target as Element;

            //manage sorters popup
            if (this.currentSorterPopupName)
                if (!el.hasAttribute('sb-header-item-sorter-name')) {
                    const currentPopupEl = this.getDisplayedSorterPopupElement();
                    if (currentPopupEl && utilities.isOutside(el, currentPopupEl))
                        this.onSorterOrderCancel(e);
                }
        });
    }

    private setupActions() {
        document.addEventListener("click", e => {
            const el = e.target as Element;

            // Manage quick actions popup
            if (this.actionsPopupIsOpen) {
                const refEl = this.getActionsPopupInstance();
                if (utilities.isOutside(el, refEl)) {
                    var currentId: string = null;
                    var currentEl = el;
                    var cpt = 0;
                    const max = 10;
                    while (!currentId && currentEl && cpt < max) {
                        if (cpt)
                            currentEl = currentEl.parentElement;
                        if (currentEl)
                            currentId = currentEl.getAttribute('banner-actions-id') || null;
                        cpt++;
                    }

                    if (currentId !== this.activeBannerId)
                        this.closeBannerActions();
                }
            }
        });

        $(window as any).on('resize', e => {
            this.closeBannerActions();
        });
    }

    setBannerActions(actions: common.ISearchBoxAction[]) {

        // Activer par defaut les actions (sera refactorise lors du rework des QuickActions dynamiques).
        for (let i = 0; i < (actions || []).length; i++)
            actions[i].isEnable = true;

        this.actions = actions;

        this.updateBannerActions();

        return this;
    }

    setOnExportButtonCallback(action: () => void) {
        this._onExportButtonCallback = action || null;
        return this;
    }

    onExportButtonClick(event: Event) {
        if (this._onExportButtonCallback)
            this._onExportButtonCallback();
    }

    onActionsPopupCloserClick(event: Event) {
        this.closeBannerActions();
    }

    onActionClick(event: KeyboardEvent, action: common.ISearchBoxAction, itemId?: string) {
        const isCtlClick = utilities.isCtlKeyPressed(event);

        this.actionClick(action, isCtlClick, itemId);
    }

    setOnAction(action: (type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean, selectedItems: common.ISelectedItem[]) => void) {
        this._onAction = action;
        return this;
    }

    getFirstEnabledAction() {
        for (let i = 0; i < (this.actions || []).length; i++) {
            const a = this.actions[i];
            if (a.isVisible)
                return a;
        }
        return null;
    }
    /** countVisibleActions(...) */
    countEnabledActions() {
        var cpt = 0;
        for (let i = 0; i < (this.actions || []).length; i++) {
            const a = this.actions[i];
            if (a.isVisible)
                cpt++;
        }
        return cpt;
    }

    getNoResultText(text: string) {
        return text || this._defaultNoResultText;
    }

    private actionClick(action: common.ISearchBoxAction, isCtlClick: boolean, itemId?: string) {
        this.actionsPopupIsOpen = false;

        const selectedItems = [] as common.ISelectedItem[];
        selectedItems.push({
            id: itemId || this.activeBannerId || ""
        } as common.ISelectedItem);

        if (this._onAction)
            this._onAction(action.type, action.selectionRule, action.confirmationTitleHtml, action.confirmationMessageHtml, isCtlClick, selectedItems);
    }

    setOnInfiniteScrollLoadMoreCallback(callback: () => void) {
        this._onInfiniteScrollLoadMoreCallback = callback || null;
        return this;
    }

    setSorterCallback(sorterCallback: (name: string, order: string) => void) {
        this._sorterCallback = sorterCallback || null;
        return this;
    }

    updateSearchParametersFromSorter(searchParameters: common.ISearchParameters) {

        if (!searchParameters)
            throw "[SearchBoxResutlsVue::updateSearchParametersFromSorter] Le parametre 'SearchParameters' est requis.";

        if (!this.currentSorter || this.currentSorter.order === common.SortOrderTypes.unset) {
            searchParameters.sorters = [];
            return searchParameters;
        }

        const newSorter = {
            fieldName: this.currentSorter.name,
            order: this.currentSorter.order,
            sorterType: null
        } as common.ISearchSorter;

        searchParameters.sorters = [newSorter];

        return searchParameters;
    }

    onItemClick(event?: MouseEvent, url?: string, id?: string, type?: string) {
        if (this._goToServerOnItemClick) {
            if (!this._onAction) throw "La propriété '_onAction' est null.";
            this._onAction(common.ToolsBarActionTypes.banner_Read, common.ToolsBarSelectionRules.bannerAction, null, null, false, [
                {
                    id: id,
                    type: type
                }
            ]);
            return;
        }

        if (url) {
            const isCtlClick = utilities.isCtlKeyPressed(event);
            utilities.redirect(url, isCtlClick);
        }
    }

    onRightClickItem(event: MouseEvent, id: string, title?: string) {
        if (!event || !id)
            return;

        //e.stopPropagation();// NE PAS METTRE POUR LES OUTSIDE CLICKS (Ex: sorters popup)
        event.preventDefault();

        const p = {
            top: event.clientY,
            left: event.clientX
        } as common.IPosition;

        this.openActionsPopup(id, p, title);
    }

    getActionsPopupInstance() {
        const inst = (this as Vue).$refs['actionsPopupInst'];
        return inst as Element;
    }

    updateBannerActions(updatedActions?: common.IToolsBarUpdatedAction[], selectedItems?: common.ISelectedItem[]) {
        selectedItems = selectedItems || [];

        for (let i = 0; i < (this.actions || []).length; i++) {
            const a = this.actions[i];

            if (updatedActions) {
                const updatedAction = this.isUpdatedAction(updatedActions, a.type);
                if (updatedAction && a.isVisible !== updatedAction.isVisible)
                    a.isVisible = updatedAction.isVisible;
            }
        }

        this.updateItemsSelection(selectedItems);
    }

    private updateItemsSelection(selectedItems: common.ISelectedItem[]) {

        if (selectedItems.length)
            this.itemsSelection = selectedItems.length === 1
                ? common.SearchBoxItemsSelectionTypes.one
                : common.SearchBoxItemsSelectionTypes.many;
        else this.itemsSelection = common.SearchBoxItemsSelectionTypes.nothing;
    }
    private isUpdatedAction(updatedActions: common.IToolsBarUpdatedAction[], actionType: common.ToolsBarActionTypes) {
        for (let i = 0; i < updatedActions.length; i++) {
            const a = updatedActions[i];
            if (actionType === a.type)
                return a;
        }
        return null;
    }

    onActionsButtonClick(event: MouseEvent, id: string, title?: string) {
        //e.stopPropagation();// NE PAS METTRE POUR LES OUTSIDE CLICKS (Ex: sorters popup)
        event.preventDefault();

        const $b = $(event.currentTarget) as JQuery;
        const o = $b.offset();
        const p = {
            top: o.top + $b.height() - 7,
            left: o.left + $b.width() - $b.width() + 3
        };

        this.openActionsPopup(id, p, title);
    }

    private openActionsPopup(id: string, popupPosition: common.IPosition, title?: string) {
        title = title || 'Actions rapides';

        // Cacher le menu contextuel si on clique une 2ème fois sur le même bouton d'actions
        // if (this._searchBoxResultsVue.activeBannerId === id) {
        //     this.closeBannerActions();
        //     return;
        // }

        this.actionsPopupTitle = title;

        // Afficher le menu contextuel
        this.activeBannerId = id;

        const $actionsPopup = $(this.getActionsPopupInstance());

        const horBuffer = 35;//px
        const vertBuffer = 25;//px
        const screenWidth = utilities.getScreenWidth();
        const modDimen = this.searchBox.getModuleDimensions();
        const popupWitdh = $actionsPopup.width();
        const popupHeight = $actionsPopup.height();
        const popupPosBottom = popupPosition.top + popupHeight;
        const popupPosRight = popupPosition.left + popupWitdh;

        if (popupPosRight > (screenWidth - horBuffer))
            popupPosition.left = screenWidth - popupWitdh - horBuffer;

        if (popupPosBottom > (modDimen.top + modDimen.height))
            popupPosition.top = (modDimen.top + modDimen.height - popupHeight - vertBuffer);

        $actionsPopup.offset(popupPosition);

        this.actionsPopupIsOpen = true;
    }

    private closeBannerActions() {
        this.actionsPopupIsOpen = false;
        this.activeBannerId = '';
    }

    updateSelectedProperties(results: common.ISearchBoxResult[]) {
        const selectedItems = this.collectSelectedItems();
        const hasSelected = !!selectedItems.length;
        for (let i = 0; i < results.length; i++) {
            const x = results[i];
            if (hasSelected) {
                const it = getSelectedById(x.id);
                x.selected = !!it;
            }
            else {
                x.selected = false;
            }
        }

        function getSelectedById(id: string) {
            for (let i = 0; i < selectedItems.length; i++) {
                const selectedItem = selectedItems[i];
                if (selectedItem.id === id)
                    return selectedItem;
            }
            return null;
        }
    }
    updateSelectedProperty(result: common.ISearchBoxResult) {
        this.updateSelectedProperties([result]);
    }
    collectSelectedItems() {
        const l = [] as common.ISelectedItem[];
        this.items.forEach(x => {
            if (x.isVisible === true && x.searchBoxSelectField.isChecked)
                l.push(x);
        });
        return l;
    }
    getItemByCheckboxId(id: string) {
        for (let i = 0; i < this.items.length; i++) {
            const x = this.items[i];
            if (x.searchBoxSelectField.id === id)
                return x;
        }
        return null;
    }

    selectAllCheckboxes(checked: boolean) {
        this.formManager.getCheckboxes().forEach(x => {
            (x as HotEditableCheckboxComponent).check(checked, false, false);
        });
    }

    infiniteScrollLoadMore() {
        if (this._onInfiniteScrollLoadMoreCallback)
            this._onInfiniteScrollLoadMoreCallback();
    }

    // SORTERS ===========================================================================
    updateSorterFromSearchParameters(searchParameters: common.ISearchParameters) {

        if (!searchParameters || !searchParameters.sorters || !searchParameters.sorters.length)
            return;

        const firstSorter = searchParameters.sorters.length ? searchParameters.sorters[0] : null;

        if (!firstSorter || !firstSorter.fieldName)
            return;

        const defaultOrder = common.SortOrderTypes.unset;

        var order: string;
        if (!firstSorter.order) {
            order = defaultOrder;
        } else {
            const lowerOrder = firstSorter.order.toLowerCase();
            if (lowerOrder === 'desc' || lowerOrder === 'descendant')
                order = common.SortOrderTypes.desc;
            else if (lowerOrder === 'asc' || lowerOrder === 'ascendant')
                order = common.SortOrderTypes.asc;
            else
                order = defaultOrder;
        }

        this.updateCurrentSorter(firstSorter.fieldName, order);
    }

    sorterPopupIsVisible(sorterName: string) {
        return this.currentSorterPopupName === sorterName;
    }

    sorterPopupUnsetChoiceIsVisible(sorterName: string) {

        return this.currentSorter &&
            this.currentSorter.name === sorterName &&
            this.currentSorter.order !== common.SortOrderTypes.unset;
    }

    getSorterOrder(sorterName: string) {

        if (!this.currentSorter)
            return common.SortOrderTypes.unset

        if (this.currentSorter.name === sorterName)
            return this.currentSorter.order;

        return common.SortOrderTypes.unset;
    }

    onSorterClick(sorterName: string, event?: Event) {
        event.preventDefault();

        this.currentSorterPopupName = sorterName;
    }

    onSorterOrderCancel(event?: Event) {
        this.currentSorterPopupName = null;
    }

    onSorterOrderClick(sorterName: string, event?: Event) {
        const thisEl = $(event.currentTarget);
        const order = thisEl.attr('order').toLowerCase();

        if (this.currentSorter && this.currentSorter.name === sorterName && this.currentSorter.order === order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            return;
        }

        this.updateCurrentSorter(sorterName, order);

        this.currentSorterPopupName = null;

        if (this._sorterCallback)
            this._sorterCallback(sorterName, order);
    }

    getTotalResultsText(total?: number, displayLoadedItems?: boolean) {
        displayLoadedItems = displayLoadedItems === true;//default is FALSE
        const t = (this.isInitialized ? total : 0) || 0;
        const l = this.getTotalLoadedItems();
        const m = !displayLoadedItems || l === t
            ? '<span class="icon"></span><span class="text">Total&nbsp;: {b}&nbsp;résultat{s}</span>'
            : '<span class="icon"></span><span class="text">Total&nbsp;: {a}&nbsp;/ {b} résultat{s}</span>';
        const r = m
            .replace("{a}", l.toString())
            .replace("{b}", t.toString())
            .replace("{s}", t > 1 ? "s" : "");

        return r;
    }

    getTotalResultsToolTip(total?: number, displayLoadedItems?: boolean) {
        displayLoadedItems = displayLoadedItems !== false;//default is TRUE
        const l = this.getTotalLoadedItems();
        const t = total || 0;
        const m = !displayLoadedItems || l === t
            ? 'Le nombre total de résultats est de {b}'
            : 'Le nombre total de résultats chargés est de {a} sur {b}';

        const r = m
            .replace("{a}", l.toString())
            .replace("{b}", t.toString());

        return r;
    }

    private getTotalLoadedItems() {
        var t = 0;
        (this.items || []).forEach(x => {
            if (x.isVisible !== false)
                t++;
        });
        return t;
    }

    private getDisplayedSorterPopupElement() {
        if (!this.currentSorterPopupName)
            return null;

        const id = "{id}_SearchBoxSorterPopup_{popupName}"
            .replace("{id}", this.searchBox.getId())
            .replace("{popupName}", this.currentSorterPopupName);
        const el = document.getElementById(id);

        return el || null;
    }

    private updateCurrentSorter(name: string, order: string) {

        this.clearSorterOrderRegistry();

        this.currentSorter = {
            name: name,
            order: order
        } as ICurrentSorter;

        this.registerSorter(name, order);
    }

    private registerSorter(sorterName: string, order?: string) {
        if (!sorterName)
            throw "L'argument 'sorterName' est requis et ne doit pas etre NULL.";

        this.sortersRegistry[sorterName] = order;
    }

    private clearSorterOrderRegistry() {
        this.sortersRegistry = {};
    }
}

export = SearchBoxResultsVue;